import CardPrimitive from './CardPrimitive';
import { ICardPrimitive } from './CardPrimitive.interfaces';

export default CardPrimitive;
export { CardPrimitive, ICardPrimitive };
